export const TERMLY_CODE_SNIPPET_SUPPORT = 'termly-code-snippet-support'
